import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import { arrayOf, bool, node, oneOfType } from 'prop-types';
import useTouchDetection from "../../hooks/useTouchDetection";
import styles from '../Select.css';
import { innerPropsPropTypes, selectPropsPropTypes } from '../shapes';
import { Placeholder } from './Placeholder';
var cx = classNames.bind(styles);
export var ValueContainer = function ValueContainer(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _props$selectProps = props.selectProps,
      value = _props$selectProps.value,
      menuIsOpen = _props$selectProps.menuIsOpen,
      isMobile = _props$selectProps.isMobile,
      handleMenuOpen = _props$selectProps.handleMenuOpen,
      keepPlaceholder = _props$selectProps.keepPlaceholder,
      isAutoOptionHeight = _props$selectProps.isAutoOptionHeight,
      inputValue = _props$selectProps.inputValue,
      classes = _props$selectProps.classes,
      valueContainerRef = _props$selectProps.valueContainerRef,
      countHiddenItems = _props$selectProps.countHiddenItems,
      autoFieldHeight = _props$selectProps.autoFieldHeight,
      isMulti = props.isMulti,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  var handleTouchEnd = useCallback(function (e, touched) {
    if (touched) {
      handleMenuOpen(e);
    }
  }, [handleMenuOpen]);
  var handleClick = useCallback(function (e) {
    handleMenuOpen(e);
  }, [handleMenuOpen]);

  var _useTouchDetection = useTouchDetection({
    condition: isMobile && !isDisabled,
    onEnd: handleTouchEnd
  }),
      _useTouchDetection2 = _slicedToArray(_useTouchDetection, 2),
      touchEvents = _useTouchDetection2[0],
      isTouch = _useTouchDetection2[1];

  var mouseEvents = !isTouch.current && !isMobile && !isDisabled ? {
    onClick: handleClick
  } : {};
  return /*#__PURE__*/React.createElement("div", _extends({}, innerProps, touchEvents, mouseEvents, {
    className: cx('ValueContainer', {
      ValueContainer_open: menuIsOpen,
      ValueContainer_autoOptionHeight: isAutoOptionHeight && value,
      ValueContainer_single: !isMulti,
      ValueContainer_multiple_selected: isMulti && (value === null || value === void 0 ? void 0 : value.length) > 0,
      autoFieldHeight: autoFieldHeight
    }, classes.valueContainer)
  }), (keepPlaceholder || !inputValue && !(value !== null && value !== void 0 && value.length) > 0) && /*#__PURE__*/React.createElement(Placeholder, props), /*#__PURE__*/React.createElement("div", {
    className: cx('ValueContainerInner', classes.hiddenTagsIndicator),
    ref: valueContainerRef
  }, children), isMulti && (!menuIsOpen || isMobile) && countHiddenItems > 0 && /*#__PURE__*/React.createElement("span", {
    className: cx('HiddenTagsIndicator')
  }, "+", countHiddenItems));
};
ValueContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: oneOfType([arrayOf(node), node]).isRequired,
  innerProps: innerPropsPropTypes,
  isDisabled: bool,
  // eslint-disable-line react/boolean-prop-naming
  isMulti: bool,
  // eslint-disable-line react/boolean-prop-naming
  selectProps: selectPropsPropTypes
} : {};